import { render, staticRenderFns } from "./InstructionsContainer.vue?vue&type=template&id=5e8435e8&scoped=true"
import script from "./InstructionsContainer.vue?vue&type=script&lang=js"
export * from "./InstructionsContainer.vue?vue&type=script&lang=js"
import style0 from "./InstructionsContainer.vue?vue&type=style&index=0&id=5e8435e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8435e8",
  null
  
)

export default component.exports